import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { productAPI, offlineSaleAPI } from '../services/api';
import { Button, Badge } from '../components/Common';
import { useAuth } from '../context/AuthContext';

const OfflineSalePage = () => {
    const { user } = useAuth();
  const billFields = user?.bill_fields || [];
  const [fieldValues, setFieldValues] = useState(
    billFields.map(f => ({ ...f, currentValue: f.value }))
  );
  const [products,   setProducts]   = useState([]);
  const [cart,       setCart]       = useState([]);
  const [selProduct, setSelProduct] = useState('');
  const [qty,        setQty]        = useState(1);
  const [unitPrice,  setUnitPrice]  = useState('');
  const [note,       setNote]       = useState('');
  const [selling,    setSelling]    = useState(false);

  useEffect(() => {
    productAPI.getAll().then(r =>
      setProducts(r.data.products.filter(p => parseFloat(p.quantity) > 0))
    );
  }, []);

  useEffect(() => {
    if (selProduct) {
      const p = products.find(x => String(x.id) === String(selProduct));
      if (p) setUnitPrice(p.sell_price);
    }
  }, [selProduct, products]);

  const addToCart = () => {
    const p = products.find(x => String(x.id) === String(selProduct));
    if (!p) { toast.error('Product select karo'); return; }
    if (parseFloat(qty) <= 0) { toast.error('Valid quantity daalo'); return; }
    if (parseFloat(qty) > parseFloat(p.quantity)) {
      toast.error(`Sirf ${p.quantity} ${p.unit} available hai`); return;
    }
    const existing = cart.find(i => String(i.product_id) === String(p.id));
    if (existing) {
      setCart(cart.map(i => i.product_id === p.id
        ? { ...i, quantity: parseFloat(i.quantity) + parseFloat(qty) } : i
      ));
    } else {
      setCart([...cart, {
        product_id: p.id,
        product_name: p.name,
        unit: p.unit,
        quantity: parseFloat(qty),
        unit_price: parseFloat(unitPrice || p.sell_price),
      }]);
    }
    setQty(1);
    setSelProduct('');
    toast.success(`${p.name} add ho gaya`);
  };

  const removeFromCart = (id) => setCart(cart.filter(i => i.product_id !== id));

  const updatePrice = (id, price) => {
    setCart(cart.map(i => i.product_id === id ? { ...i, unit_price: parseFloat(price) || 0 } : i));
  };

  const updateQty = (id, q) => {
    setCart(cart.map(i => i.product_id === id ? { ...i, quantity: parseFloat(q) || 0 } : i));
  };

  const subtotal = cart.reduce((s, i) => s + i.quantity * i.unit_price, 0);

  let runningTotal = subtotal;
  const fieldCalcs = fieldValues.map(f => {
    const val = parseFloat(f.currentValue) || 0;
    let amount = 0;
    if (f.type === 'percent') {
      amount = Math.round(runningTotal * val / 100 * 100) / 100;
    } else {
      amount = val;
    }
    const isDiscount = f.label.toLowerCase().includes('discount');
    if (isDiscount) {
      runningTotal -= amount;
    } else {
      runningTotal += amount;
    }
    return { ...f, amount, isDiscount };
  });
  const total = runningTotal;

  const handleSale = async () => {
    if (cart.length === 0) { toast.error('Cart empty hai'); return; }
    setSelling(true);
    try {
      const res = await offlineSaleAPI.create({
        items: cart.map(i => ({
          product_id: i.product_id,
          quantity: i.quantity,
          unit_price: i.unit_price,
        })),
        note,
      });
      toast.success(res.data.message);
      setCart([]);
      setNote('');
      setSelProduct('');
      // Products reload karo
      productAPI.getAll().then(r =>
        setProducts(r.data.products.filter(p => parseFloat(p.quantity) > 0))
      );
    } catch (err) {
      toast.error(err.response?.data?.message || 'Sale nahi hui');
    } finally { setSelling(false); }
  };

  return (
    <div className="page">
      <div style={{ marginBottom: 24 }}>
        <h1 className="page-title">⚡ Offline Sale</h1>
        <p className="page-sub">Bina bill ke quick sale — stock auto deduct hoga</p>
      </div>

      <div className="two-col">
        {/* LEFT — Item Add */}
        <div>
          <div className="card">
            <div className="card-header">
              <span className="card-title">➕ Item Add Karo</span>
            </div>
            <div className="card-body">
              <div className="form-group">
                <label className="form-label">Product *</label>
                <select className="form-input" value={selProduct}
                  onChange={e => setSelProduct(e.target.value)}>
                  <option value="">-- Product choose karo --</option>
                  {products.map(p => (
                    <option key={p.id} value={p.id}>
                      {p.name} ({p.quantity} {p.unit} available)
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Quantity</label>
                  <input className="form-input" type="number" step="0.01" min="0.01"
                    value={qty} onChange={e => setQty(e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="form-label">Price (₹)</label>
                  <input className="form-input" type="number" step="0.01" min="0"
                    value={unitPrice} onChange={e => setUnitPrice(e.target.value)} />
                </div>
              </div>
              <Button onClick={addToCart} style={{ width: '100%', justifyContent: 'center' }}>
                + Cart Mein Add Karo
              </Button>
            </div>
          </div>

          {/* Note */}
          <div className="card">
            <div className="card-body">
              <div className="form-group">
                <label className="form-label">Note (Optional)</label>
                <input className="form-input" placeholder="Koi note..."
                  value={note} onChange={e => setNote(e.target.value)} />
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT — Cart */}
        <div>
          <div className="card">
            <div className="card-header">
              <span className="card-title">🛒 Cart ({cart.length})</span>
              {cart.length > 0 && (
                <button className="btn btn-ghost btn-sm" onClick={() => setCart([])}>Clear</button>
              )}
            </div>

            {cart.length === 0 ? (
              <div style={{ padding: 24, textAlign: 'center', color: 'var(--text3)' }}>
                Items add karo
              </div>
            ) : (
              <>
                <div className="table-wrap">
                  <table>
                    <thead>
                      <tr>
                        <th>Product</th>
                        <th>Qty</th>
                        <th>Price</th>
                        <th>Total</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {cart.map(i => (
                        <tr key={i.product_id}>
                          <td><strong>{i.product_name}</strong></td>
                          <td>
                            <input type="number" className="form-input"
                              style={{ width: 70, padding: '4px 8px' }}
                              value={i.quantity} min="0.01" step="0.01"
                              onChange={e => updateQty(i.product_id, e.target.value)} />
                          </td>
                          <td>
                            <input type="number" className="form-input"
                              style={{ width: 80, padding: '4px 8px' }}
                              value={i.unit_price} min="0" step="0.01"
                              onChange={e => updatePrice(i.product_id, e.target.value)} />
                          </td>
                          <td style={{ color: 'var(--accent2)', fontWeight: 600 }}>
                            ₹{(i.quantity * i.unit_price).toFixed(0)}
                          </td>
                          <td>
                            <button className="btn btn-sm"
                              style={{ color: 'var(--danger)', background: 'rgba(255,107,107,.1)' }}
                              onClick={() => removeFromCart(i.product_id)}>✕</button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Total + Sale Button */}
                <div style={{ padding: 16, borderTop: '1px solid var(--border)' }}>
                  
                  {/* Subtotal */}
                  <div style={{ display:'flex', justifyContent:'space-between', marginBottom: 8 }}>
                    <span style={{ color:'var(--text2)', fontSize: 13 }}>Subtotal:</span>
                    <span style={{ fontWeight: 600 }}>₹{subtotal.toFixed(0)}</span>
                  </div>

                  {/* Bill Fields */}
                  {fieldValues.map((f, index) => (
                    <div key={index} style={{ marginBottom: 8 }}>
                      <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom: 4 }}>
                        <span style={{ color:'var(--text2)', fontSize: 12, flex: 1 }}>
                          {f.label}{f.type === 'percent' ? ' (%)' : ' (₹)'}:
                        </span>
                        <input
                          type="number"
                          className="form-input"
                          style={{ width: 70, padding:'4px 8px' }}
                          value={f.currentValue}
                          min={0}
                          onChange={e => {
                            const updated = [...fieldValues];
                            updated[index].currentValue = e.target.value;
                            setFieldValues(updated);
                          }}
                        />
                      </div>
                      {fieldCalcs[index] && fieldCalcs[index].amount > 0 && (
                        <div style={{
                          display:'flex', justifyContent:'space-between',
                          color: fieldCalcs[index].isDiscount ? 'var(--warn)' : 'var(--text2)',
                          fontSize: 12,
                        }}>
                          <span>{f.label} {f.type==='percent' ? `(${f.currentValue}%)` : ''}</span>
                          <span>{fieldCalcs[index].isDiscount ? '-' : '+'}₹{fieldCalcs[index].amount.toFixed(0)}</span>
                        </div>
                      )}
                    </div>
                  ))}

                  {/* Grand Total */}
                  <div style={{
                    display: 'flex', justifyContent: 'space-between',
                    alignItems: 'center', marginTop: 12, marginBottom: 16,
                    padding: '10px 0', borderTop: '1px solid var(--border)',
                  }}>
                    <span style={{ fontSize: 16, fontWeight: 600, color: 'var(--text2)' }}>
                      Total:
                    </span>
                    <span style={{ fontSize: 22, fontWeight: 700, color: 'var(--accent2)' }}>
                      ₹{total.toFixed(0)}
                    </span>
                  </div>
                  <Button
                    variant="success"
                    loading={selling}
                    onClick={handleSale}
                    style={{ width: '100%', justifyContent: 'center', padding: 14, fontSize: 16 }}
                  >
                    ⚡ Sale Karo
                  </Button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfflineSalePage;